// Clientes Component
import React from 'react';
// material
import { Button, Card, CardHeader, CardContent, Divider, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Swal from 'sweetalert2';
// components
import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
// mock
import RTabla from '../../componentes/tabla';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, workWithLocalStorage } from '../../auxiliares/funciones';
import Alta from './alta';
// ----------------------------------------------------------------------

export default function Index(props) {
  const [lista, setLista] = React.useState([]);
  const [cargado, setCargado] = React.useState(false);

  const campos = ['vip', 'nombre', 'telefono', 'email', 'dni', 'notas', 'num_citas', 'num_cupones', 'estado', 'fechaAlta'];
  const cabecera = ['VIP', 'Nombre', 'Teléfono', 'Email', 'Dni', 'Notas', 'Nº Citas', 'Nº Cupones', 'Estado', 'Fecha Alta'];
  const usuario = workWithLocalStorage('get', 'usuario', null);

  React.useEffect(() => {
    if (!cargado) {
      if (props.showLoader) props.showLoader(true);
      const bodyJson = JSON.stringify(buildBody(usuario.token, { busqueda: '' }));
      fetch(`${CONFIG.api}clientes/lista`, {
        method: 'POST',
        body: bodyJson,
        headers: { 'Content-Type': 'application/json' }
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.error === 0 && !isEmpty(result.data)) {
            setLista(result.data);
          } else {
            setLista([]);
          }
          if (props.showLoader) props.showLoader(false);
          setCargado(true);
        })
        .catch((err) => {
          console.error(err);
          if (props.showLoader) props.showLoader(false);
          setCargado(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargado]);

  const altaCliente = (objeto) => {
    if (objeto !== null) {
      props.setTabs({ nombre: `Editar Cliente #${objeto.id}`, componente: Alta, params: { id: objeto.id }, visible: true });
    } else {
      props.setTabs({ nombre: 'Alta Cliente', componente: Alta, params: {}, visible: true });
    }
  };

  const Actualiza = () => {
    if (props.showLoader) props.showLoader(true);
    setCargado(false);
  };

  const validaBorrar = (obj) => obj.activo === 1;
  const validaActivar = (obj) => obj.activo !== 1;

  const Activar = (obj) => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'clientes',
      activo: 1,
      id: obj.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Cliente activado!';
        if (result.error === 0) {
          setLista([]);
          setCargado(false);
        } else {
          msg = result.errorMessage;
        }
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  const Borrar = (obj) => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'clientes',
      activo: 0,
      id: obj.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Cliente desactivado!';
        if (result.error === 0) {
          setLista([]);
          setCargado(false);
        } else {
          msg = result.errorMessage;
        }
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  const theme = useTheme();
  const acciones = [
    {
      color: undefined,
      nombre: 'Ver',
      icono: <Iconify icon="eva:edit-fill" style={{ fontSize: '20px' }} />,
      funcion: altaCliente,
      estilo: { backgroundColor: theme.palette.gradients.primary, color: theme.palette.common.white },
      condition: null
    },
    {
      color: 'error',
      nombre: 'Borrar',
      icono: <i />,
      funcion: Borrar,
      estilo: {},
      condition: validaBorrar
    },
    {
      color: 'warning',
      nombre: 'Activar',
      icono: <i />,
      funcion: Activar,
      estilo: {},
      condition: validaActivar
    }
  ];

  return (
    <Page title="Clientes" key={lista.length}>
      <Card sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflow: 'hidden' }}>
        <CardHeader
          action={
            <Stack direction="row" spacing={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ color: 'white', fontWeight: 'bold' }}
                to="#"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => altaCliente(null)}
              >
                Alta
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={{ color: 'white', fontWeight: 'bold' }}
                to="#"
                startIcon={<Iconify icon="eva:refresh-fill" />}
                onClick={() => Actualiza()}
              >
                Actualizar
              </Button>
            </Stack>
          }
          title="Clientes"
        />
        <Divider style={{ margin: '15px 0' }} />
        <CardContent sx={{ p: { xs: 1, sm: 2 }, width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box', overflowX: 'auto' }}>
          <RTabla lista={lista} campos={campos} cabecera={cabecera} acciones={acciones} />
        </CardContent>
      </Card>
    </Page>
  );
}
